// Get Metro cookie ID
window.metroCookieId = function () {
  var hsOptOut = docCookies.getItem("__hs_opt_out");
  var wmc = docCookies.getItem("wmc");
  var metroId = "";
  if ((!hsOptOut || hsOptOut === "no") && wmc) {
    var parsedWmc = JSON.parse(wmc);
    metroId = parsedWmc.cookie_id || parsedWmc.visitor_id;
  }
  return metroId;
}

window.inlineCtaGaEvent = function (id) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "Resources - Body - Inline CTA - " + id,
    eventCategory: "Resources",
    eventAction: "Event",
    eventLabel: "Resources - Body - Inline CTA - " + id
  });
}

jQuery(document).ready(function ($) {
  let topPosBr = 0;

  /* Matched Height Elements */
  function matchedHeightBoxes() {
    if ($(window).width() > 767) {
      $(function () {
        $(".row").each(function (i, elem) {
          $(elem)
            .find(".card__text, .promobox-inner, .card-thumb-wrapper") // Only children of this row.
            .matchHeight({ byRow: false }); // Row detection gets confused so disable it.
          $(elem).find(".card-plain").matchHeight({ byRow: true });
        });
      });
    }
  }
  $(window).on("load resize", matchedHeightBoxes());

  /**
   * Cookie settings link
   */
  $(".hs-show-cookie-banner").click(function(event) {
    event.preventDefault();

    var _hsp = (window._hsp = window._hsp || []);
    _hsp.push(['showBanner']);
  });

  /**
   * Fix autocomplete left when search input value is not empty
   */
  var autocompleteSearchInput = $("input[name='s'");

  autocompleteSearchInput
    .on("focus", function () {
      var _this = $(this);

      setTimeout(function () {
        var autocomplete = $(".algolia-autocomplete");

        autocomplete.addClass("active");
        autocomplete.css({
          left: _this.offset().left
        });
      }, 1000);
    })
    .on("blur", function () {
      $(".algolia-autocomplete").removeClass("active");
    });

  /* Menu Handlers */

  /* Generic Handling*/

  // Dropdown open/close behavior handler.
  Array.prototype.slice
    .call(document.querySelectorAll(".dropdown-holder"))
    .forEach(function (dropdown) {
      var menuTitle = dropdown.querySelector(".dropdown-title");
      var clickEventListener = function () {
        dropdown
          .querySelector(".dropdown-menu-icon")
          .classList.toggle("active");
        dropdown
          .querySelector(".dropdown-menu-holder")
          .classList.toggle("active");
      };

      menuTitle.addEventListener("click", clickEventListener);
    });
  
  // Dropdown input select value handler.
  $(".dropdown-holder--input li > a").on("click", function (e) {
    e.preventDefault();

    const dropdownHolder = $(this).parents(".dropdown-holder");
    const dropdownMenuHolder = $(this).parents(".dropdown-menu-holder");
    const dropdownMenuIcon = dropdownMenuHolder.find(".dropdown-menu-icon");

    dropdownMenuHolder.removeClass("active");
    dropdownMenuIcon.removeClass("active");

    dropdownHolder.find(".dropdown-title-text").html($(this).text());
    dropdownHolder.find("input").val($(this).data("value"));
  });

  // Deactivate menu in case of selecting anywhere
  // in the document.
  document.addEventListener("click", function (e) {
    var holders = document.querySelectorAll(".dropdown-holder");
    Array.prototype.slice.call(holders).forEach(function (holder) {
      if (
        !holder.contains(e.target) ||
        e.target.tagName.toLowerCase() === "a"
      ) {
        holder.querySelector(".dropdown-menu-icon").classList.remove("active");
        holder
          .querySelector(".dropdown-menu-holder")
          .classList.remove("active");
      }
    });
  });

  /* Terms Menu handler */

  // Find Terms within the page.
  var terms = document.querySelectorAll(".term");

  // Retrieve the menu to update.
  var termsArray = Array.from(terms);
  var termsFirstTitle = document.querySelector(
    ".terms-menu.dropdown-holder .dropdown-title-text"
  );

  var isInStickyMenuAligment = function (element, scrollElement) {
    var elementRect = element.getBoundingClientRect();
    var fromTop = scrollElement ? scrollElement.getBoundingClientRect().top : 0;
    return elementRect.top <= fromTop && elementRect.bottom > fromTop;
  };

  var stickyMenu = document.querySelector(".terms-menu");
  // Scroll event for terms handling
  window.addEventListener("scroll", function () {
    var term = termsArray.find(function (element) {
      return isInStickyMenuAligment(element, stickyMenu);
    });

    if (termsFirstTitle) {
      termsFirstTitle.innerHTML = term ? term.title : stickyMenu.title;
    }
  });

  // Sticky social on scroll
  const social = document.getElementById("social");
  if ($(window).width() > 767 && social) {
    const breadcrumb = document.getElementById("breadcrumb");
    topPosBr =
      (breadcrumb ? breadcrumb.getBoundingClientRect().top : 0) +
      window.scrollY;
    const topPosSocial =
      (social ? social.getBoundingClientRect().top : 0) + window.scrollY;
    social.style.marginTop = -(topPosSocial - topPosBr + 50) + "px";
  }

  // Term Links events.
  if ("a.terms-link") {
    // Add smooth scrolling to all links
    $("a.terms-link").on("click", function (event) {
      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        var targetOffset = $(hash).offset().top;
        $("html, body").animate(
          {
            scrollTop: targetOffset
            //scrollTop: $(hash).offset().top
          },
          800,
          function () {
            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
          }
        );
      } // End if
    });
  }

  // FAQ section accordion
  $(".faq__question dt").click(function(e) {
    var parent = $(this).parent();
    var expanded = parent.attr("aria-expanded");
    
    if (expanded === 'true') {
      parent.attr("aria-expanded", 'false');
      parent.find("dd").slideUp(300);
    } else {
      parent.attr("aria-expanded", 'true');
      parent.find("dd").slideDown(300);
    }
  });

  // Custom table of contents
  $(".table-contents").each(function() {
    var list = $(this).find("ul");
    var titles = $(".article-container > h2");

    // do not show table of contents if titles are less than two
    if (titles.length <= 1) return;

    $(this).addClass("table-contents--active");

    function checkActiveItem() {
      list.find('li').removeClass("active");
      var selectedTitle = null;

      titles.each(function() {
        if (
            selectedTitle === null &&
            $(this).offset().top > $(window).scrollTop() && 
            $(this).offset().top + $(this).height() < $(window).scrollTop() + window.innerHeight
        ) {
          selectedTitle = $(this);
        }
      });

      if (selectedTitle !== null && selectedTitle.length) {
        var titleText = selectedTitle.text().replace(/\:/g, "");
        $("[data-id='" +titleText+"']").addClass("active");
      }
    }

    $(window).scroll(checkActiveItem);

    // Click event on table of contents item
    $(this).on('click', 'li > a', function(event) {
      event.preventDefault();
      var elem = $("[id='" + $(this).parent().attr("data-id") + "']");

      if (elem.length) {
        $("html, body").animate({ scrollTop: elem.offset().top - 40 }, 400);
      }
    })

    titles.each(function() {
      var titleText = $(this).text().replace(/\:/g, "");
      $(this).attr("id", titleText);

      list.append($("<li/>", {
        'data-id': titleText,
        'html': $("<a/>", {
          'href': "#" + titleText,
          'html': titleText
        })
      }));
    });

    checkActiveItem();
  });

  // Open the external URL links in a new tab - Universal effect.
  $("a").each(function () {
    var a = new RegExp("/" + window.location.host + "/");
    if (!a.test(this.href)) {
      this.setAttribute("target", "_blank");
    }
  });

  function readingTime() {
    const text = document.getElementById("main").innerText;
    const wpm = 200;
    const words = text.trim().split(/\s+/).length;
    const time = Math.ceil(words / wpm);
    const element = document.getElementById("time");

    if (element) element.innerText = time + " min read";
  }
  readingTime();
});
